import { CashTransactionGroupType } from './CashTransactionGroupType';
import {
  ArrayNotEmpty,
  IsBoolean,
  IsEnum,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsUUID,
} from 'class-validator';

export class PostCashListTransactionGroupDto {
  @IsEnum(CashTransactionGroupType)
  type!: CashTransactionGroupType;

  @IsOptional()
  @ArrayNotEmpty()
  @IsNumber({}, { each: true })
  coins?: number[];

  @IsOptional()
  @IsNumber()
  bankAccountAmount?: number;

  @IsOptional()
  @IsInt()
  immediateFeeAmount?: number;
  @IsOptional()
  @IsBoolean()
  immediateFeeTracked?: boolean;
  @IsOptional()
  @IsInt()
  separateFeeAmount?: number;
  @IsOptional()
  @IsNumber()
  separateFeePercentage?: number;

  @IsOptional()
  notes?: string;

  @IsNotEmpty()
  @IsUUID(4)
  cashListId!: string;
}
